// import { Aion__factory } from '@/contracts';
// import { CONSTANT } from '@/store/constants';
// import { sharedProvider } from '@/store/provider';
// import { useAddress } from '@/store/selector';
// import { ErrorMessage } from '@/utils/errors';
// import { waitForTransactionReceipt } from '@/utils/wait-transaction';
// import { MiniKit } from '@worldcoin/minikit-js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { motion } from 'motion/react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMiniAppLink } from '@/utils/mini-app-link';
// import useSWR from 'swr';
// import { toastApp } from '../../toast-message/sonner';
import { aniProps } from '../claim-free-wld';
import { ModalSuccess } from './modal-success';

dayjs.extend(utc);
// async function callDaily({ address }: { address: string }) {
//     try {
//         const provider = sharedProvider.get(CONSTANT.RPC_WLD);

//         const contract = Aion__factory.connect(
//             CONSTANT.CONTRACT_CLAIM_AION,
//             provider
//         );
//         const data = await contract.nextTimeCanClaim(address);

//         const currentTime = Math.floor(Date.now() / 1000);

//         return {
//             isAvailableClaim: Number(data) <= currentTime,
//             time: Number(data),
//         };
//     } catch (error) {
//         console.error('Error fetching daily Aion:', error);
//         return null;
//     }
// }

// function useCheckDailyAion() {
//     const address = useAddress();
//     return useSWR({ address }, callDaily);
// }
const getTodayDay = () => {
    const currentDay = new Date().toISOString();
    return currentDay.split('T')[0];
};

export const ClaimDailyAion = () => {
    const { t } = useTranslation();
    const [exclamationIcon, setExclamationIcon] = useState(
        localStorage.getItem('exclamationIcon') === getTodayDay()
    );

    // const [loading, setLoading] = useState(false);

    const [isOpenModal, setIsOpenModal] = useState(false);

    // const { data, mutate } = useCheckDailyAion();

    // const isAvailableClaim = data?.isAvailableClaim ?? false;

    const hanleToggleModal = useCallback(() => {
        setIsOpenModal((prev) => !prev);
    }, []);

    // const handleClaim = useCallback(async () => {
    //     try {
    //         if (!MiniKit.isInstalled()) {
    //             throw new Error('Minikit not install');
    //         }

    //         setLoading(true);

    //         const payload = {
    //             transaction: [
    //                 {
    //                     address: CONSTANT.CONTRACT_CLAIM_AION,
    //                     abi: Aion__factory.abi,
    //                     functionName: 'claim',
    //                     args: [],
    //                 },
    //             ],
    //         };

    //         const { finalPayload } =
    //             await MiniKit.commandsAsync.sendTransaction(payload);

    //         if (finalPayload.status === 'error') {
    //             const code = finalPayload.error_code as string;
    //             let msg = null;
    //             if (code === 'invalid_request') {
    //                 msg = 'You are not eligible for reward';
    //             } else {
    //                 msg = ErrorMessage(finalPayload.error_code);
    //             }

    //             throw new Error(
    //                 msg || 'Something went wrong, please try again'
    //             );
    //         }
    //         await waitForTransactionReceipt(finalPayload.transaction_id);
    //         await mutate();
    //         toastApp.success(t('🎉 You just received 1 $AION!'));

    //         setIsOpenModal(true);
    //     } catch (error: any) {
    //         const msg =
    //             error?.message || 'Something went wrong, please try again';
    //         toastApp.error(t(msg));
    //     } finally {
    //         setLoading(false);
    //     }
    // }, [mutate, t]);

    return (
        <div className="flex items-center justify-between p-4 bg-[#141414] rounded-xl mb-3">
            <div className="flex items-center gap-x-2">
                {/* <img
                    src={
                        'https://dd.dexscreener.com/ds-data/tokens/worldchain/0x26064dd7821f351202c61f0deb97678eef265e36.png?key=e96ada%22%22icon%22:%20%22https://dd.dexscreener.com/ds-data/tokens/worldchain/0x26064dd7821f351202c61f0deb97678eef265e36.png?key=e96ada'
                    }
                    className="w- h-6"
                /> */}
                <p className="text-white text-sm">
                    {t('Open a Trade and Claim WLD')}
                </p>
            </div>
            <motion.button
                {...aniProps}
                // disabled={loading}
                className=" rounded-full p-[1px] cursor-pointer relative "
                style={{
                    background:
                        'linear-gradient(90deg, #FF975B 0%, #E6FF8E 50%, #5FFFB4 100%)',
                }}
                onClick={() => {
                    setExclamationIcon(true);
                    localStorage.setItem('exclamationIcon', getTodayDay());

                    window.open(
                        formatMiniAppLink('https://worldcoin.org/mini-app/?app_id=app_0d4b759921490adc1f2bd569fda9b53a&path=/stack'),
                        '_blank'
                    );
                    // if (!isAvailableClaim) {
                    //     const expireTime = Number(data?.time ?? 0);
                    //     const now = dayjs.utc();
                    //     const expire = dayjs.unix(expireTime).utc();

                    //     const rawHoursLeft = expire.diff(now, 'hour', true);
                    //     const hoursLeft = Math.max(0, Math.ceil(rawHoursLeft));

                    //     toastApp.error(
                    //         <p className="text-xs">
                    //             {t(
                    //                 'Daily claim already used. Come back in time hours to get your next 1 $AION.',
                    //                 { time: hoursLeft }
                    //             )}
                    //         </p>
                    //     );
                    //     return;
                    // }
                    // if (loading) {
                    //     return;
                    // }

                    // handleClaim();
                }}
            >

                    {!exclamationIcon ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            className="w-3 h-3 absolute -top-0 -left-1 z-50"
                        >
                            <path
                                d="M0 5.5C0 8.53757 2.46243 11 5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5Z"
                                fill="#FF4B4B"
                            />
                            <path
                                d="M5.50024 2.44409V6.41631"
                                stroke="white"
                                stroke-width="1.22222"
                            />
                            <path
                                d="M5.50024 7.3335L5.50024 8.55572"
                                stroke="white"
                                stroke-width="1.22222"
                            />
                        </svg>
                    ) : null}
                <div
                    className="bg-[#1C1C1C] rounded-full px-[7px] py-[3px] flex items-center gap-1 w-full"
                    style={{
                        maskImage:
                            'linear-gradient(-75deg,var(--primary) calc(var(--x) + 20%),transparent calc(var(--x) + 30%),var(--primary) calc(var(--x) + 100%))',
                    }}
                >
                    <p className="text-white font-[450] text-sm leading-5 truncate">
                        {t('Claim')}
                    </p>

                
                    {/* {loading ? (
                        <>
                            <Spinner />
                            <p className="text-white font-[450] text-sm leading-5 truncate">
                                {t('Claiming')}
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="text-white font-[450] text-sm leading-5 truncate">
                                {t('Claim Aion')}
                            </p>
                        </>
                    )} */}
                </div>
                <span
                    style={{
                        mask: 'linear-gradient(rgb(0,0,0), rgb(0,0,0)) content-box exclude,linear-gradient(rgb(0,0,0), rgb(0,0,0))',
                        WebkitMask:
                            'linear-gradient(rgb(0,0,0), rgb(0,0,0)) content-box exclude,linear-gradient(rgb(0,0,0), rgb(0,0,0))',
                        backgroundImage:
                            'linear-gradient(-75deg,var(--primary)/10% calc(var(--x)+20%),var(--primary)/50% calc(var(--x)+25%),var(--primary)/10% calc(var(--x)+100%))',
                    }}
                    className="absolute inset-0 z-10 block rounded-[inherit] p-px"
                />
            </motion.button>

            {isOpenModal && (
                <ModalSuccess isOpen={isOpenModal} onClose={hanleToggleModal} />
            )}
        </div>
    );
};
